<reach-bottom-menu
	class="open-mobile-menu z-50"
	[openOnStartup]="false"
	[lightBg]="true"
	(opened)="onMenuOpened()"
	(closed)="onMenuClosed()"
>
	<ng-container ngProjectAs="[~title]"> See myReach in... </ng-container>

	<ng-container
		[ngTemplateOutlet]="cardTpl"
		[ngTemplateOutletContext]="{ item: reachKey }"
	></ng-container>

	<div class="legacy-separator"></div>

	<ng-container
		[ngTemplateOutlet]="cardTpl"
		[ngTemplateOutletContext]="{ item: browserKey }"
	></ng-container>
</reach-bottom-menu>

<ng-template #cardTpl let-item="item">
	<div class="menu-card">
		<img [src]="itemImageUrl(item)" [alt]="itemName(item)" />

		<span class="card-name">
			{{ itemName(item) }}
		</span>

		<button [class.filled]="isReach(item)" (click)="openKey(item)">
			<div [class.legacy-hidden]="!isReach(item)">Open</div>
			<div [class.legacy-hidden]="isReach(item)">Continue</div>
		</button>
	</div>
</ng-template>
